import { styled } from '@material-ui/styles';
import React, { CSSProperties } from 'react';

import { Message } from '../../../../../Locales/I18nService';
import { BaseDialog } from '../../../../../Plugins/FloorPlan/Widgets/BaseDialog';
import { ButtonVariant, CustomButton } from '../../../../Components/Views/CustomButton/CustomButton';

export type YesNoDialogProps = {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    onClose?: VoidFunction;
    leftAction?: React.ReactNode;
    onClickYes: (setValidating: (validating: boolean) => void) => void;
    rightAction?: React.ReactNode;
    onClickNo: (setValidating: (validating: boolean) => void) => void;
    yesHighlight?: boolean;
    noHighlight?: boolean;
    enableCloseOutside?: boolean;
    header?: React.ReactNode;
    body?: React.ReactNode;

    styles?: { rightAction?: CSSProperties };

    fullWidthButtons?: boolean;
};

export const YesNoChoiceDialog = ({
    title,
    subtitle,
    onClose,
    leftAction,
    onClickYes,
    rightAction,
    onClickNo,
    yesHighlight,
    noHighlight,
    enableCloseOutside,
    styles,
    fullWidthButtons,
    children,
}: React.PropsWithChildren<YesNoDialogProps>) => {
    const [yesValidating, setYesValidating] = React.useState(false);
    const [noValidating, setNoValidating] = React.useState(false);

    const onValidateYes = () => onClickYes(setYesValidating);
    const onValidateNo = () => onClickNo(setNoValidating);

    const onCloseDialog = () => {
        if (!yesValidating && !noValidating && onClose) {
            onClose();
        }
    };

    return (
        <BaseDialog title={title} subtitle={subtitle} onClose={onCloseDialog} enableCloseOutside={enableCloseOutside}>
            <Content>
                <CustomButton
                    title={leftAction || <Message id="COMMON_YES" />}
                    styles={{ root: BtnStyle }}
                    variant={yesHighlight ? ButtonVariant.Blue : ButtonVariant.BorderedBlue}
                    onClick={onValidateYes}
                    isBusy={yesValidating}
                    disabled={noValidating}
                />
                <CustomButton
                    title={rightAction || <Message id="COMMON_NO" />}
                    styles={{ root: { ...BtnStyle, ...styles?.rightAction } }}
                    variant={noHighlight ? ButtonVariant.Blue : ButtonVariant.BorderedBlue}
                    onClick={onValidateNo}
                    isBusy={noValidating}
                    disabled={yesValidating}
                />
            </Content>
            {children}
        </BaseDialog>
    );
};

const Content = styled('div')({ marginTop: 37, display: 'flex', gap: 12 });
const BtnStyle: CSSProperties = { flex: 1 };
